import apiClient from '@/vue/apiClient.js'

export default {
  async getCustomFields() {
    const url = '/settings/application/custom-fields'
    const response = await apiClient.get(url)
    return response.data
  },
  async createCustomField(customField) {
    const url = '/settings/application/custom-fields/add'
    const response = await apiClient.post(url, customField)
    return response.data
  },
  async deleteCustomField(customFieldKey) {
    const url = `/settings/application/custom-fields/${customFieldKey}`
    const response = await apiClient.delete(url)
    return response.data
  },
  async editCustomField(customField) {
    const url = `/settings/application/custom-fields/${customField.key}`
    const response = await apiClient.put(url, customField)
    return response.data
  },
}
